// extracted by mini-css-extract-plugin
module.exports = {"container":"_80ad21f8ef--container--JIxZA","title":"_80ad21f8ef--title--ncCHK","description":"_80ad21f8ef--description--xuHZ_","controls":"_80ad21f8ef--controls--naKMt"};